const localization = {
  defaultLocale: 'ar',
  // fallback: true,
  locales: [
    {
      code: 'ar',
      label: 'Arabic (العربية)',
      rtl: true,
    },
  ],
}

export default localization